/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import dateFormat from '@/tools/dateFormat';
import { invoiceStatus } from './search';
function handleEmpty(r, c, v) {
  return v || '-';
}
// 删除按钮禁用
export const delDisabled = auditStatus => {
  return [1, 2, 3].includes(auditStatus);
};
// 上传按钮禁用
export const uploadDisabled = ({ auditStatus, firstAuditStatus }) => {
  if ([1, 3].includes(auditStatus)) {
    return true;
  }
  if (auditStatus === 2) {
    // 只有委托代开会有firstAuditStatus字段
    if (firstAuditStatus === 0) return false;
    if (firstAuditStatus) return true;
    return false;
  }
  return false;
};
// 下载按钮禁用
export const downloadDisabled = auditStatus => {
  return [0].includes(auditStatus);
};
// 补充上传按钮禁用
export const supplementaryUploadDisabled = ({
  auditStatus,
  firstAuditStatus
}) => {
  if ([0, 1].includes(auditStatus)) {
    return true;
  }
  if ([2].includes(auditStatus)) {
    return firstAuditStatus === 0 ? true : false;
  }
  return false;
};
export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  customerName: {
    label: '客户企业',
    prop: 'customerName'
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },

  wsqy: {
    label: '完税企业名称',
    prop: 'customerName',
    formatter: handleEmpty
  },
  qyNo: {
    label: '纳税人识别号',
    prop: 'enterpriseIdentifierNo',
    formatter: handleEmpty
  },
  month: {
    label: '所得月份',
    prop: 'proofMonth',
    formatter(r) {
      const { proofMonthStart = '', proofMonthEnd = '' } = r;
      if (
        proofMonthStart === proofMonthEnd ||
        !proofMonthEnd ||
        !proofMonthStart
      ) {
        return proofMonthStart || '-';
      }
      return `${proofMonthStart} - ${proofMonthEnd}`;
    }
  },
  startDate: {
    label: '税款所属期起',
    prop: 'taxPaymentStart',
    formatter: handleEmpty
  },
  endDate: {
    label: '税款所属期止',
    prop: 'taxPaymentEnd',
    formatter: handleEmpty
  },
  wsCount: {
    label: '完税人数',
    formatter: row => {
      return row['peopleCount'] || 0;
    }
  },
  uploadDt: {
    label: '上传日期',
    prop: 'updateDt',
    formatter(r, c, v) {
      return v ? dateFormat(v) : '-';
    }
  },
  newDt: {
    label: '最新上传日期',
    formatter(r) {
      return r.updateDt ? dateFormat(r.updateDt) : '-';
    }
  },
  uploadUserPhone: {
    label: '上传账号',
    prop: 'uploadUserPhone'
  },
  auditStatus: {
    label: '状态',
    prop: 'uploadUserPhone',
    render: function(h, ctx, r) {
      const { auditStatus, auditReason } = r;
      if (auditStatus == 2 && auditReason) {
        return (
          <el-button
            type="text"
            onClick={() => {
              ctx.parent.$alert(auditReason);
            }}
          >
            已驳回
          </el-button>
        );
      }
      return (
        <span>
          {(invoiceStatus.find(i => i.key == auditStatus) || {}).name}
        </span>
      );
    }
  },
  submitDt: {
    label: '提交时间',
    formatter(r) {
      return r.submitDt ? dateFormat(r.submitDt) : '';
    }
  }
};
